<div class="m-t-xl">
  <p-accordion id="p-accordion-default-35">
    <p-accordionTab id="p-accordionTab-default-52">
      <p-header>
        <div [innerHtml]="accordionTitle"></div>
      </p-header>
      <div class="p-content">
        <div [innerHtml]="html"></div>
        <div class="row m-t-xl">
          <div class="col-12 col-md-11">
            <div class="img-panel" *ngIf="deviceType === DEVICE_DESKTOP">
              <img class="img-fluid" [src]="desktopImageUrl" alt="{{ desktopAltText }}" />
            </div>
            <div class="img-panel" *ngIf="deviceType === DEVICE_TABLET">
              <img class="img-fluid" [src]="tabletImageUrl" alt="{{ tabletAltText }}" />
            </div>
            <div class="img-panel" *ngIf="deviceType === DEVICE_MOBILE">
              <img class="img-fluid" [src]="mobileImageUrl" alt="{{ mobileAltText }}" />
            </div>
          </div>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
